<div class="row" *ngIf="(carrierEquipment | json) != '{}'">
    <div class="col-sm-12">
        <h4>Equipment</h4>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Trailer Type</label>
                <select name="trailerTypeID" [(ngModel)]="carrierEquipment.trailerTypeID" class="form-select" required>
                    <option *ngFor="let trailerType of trailerTypeList" value="{{trailerType.trailerTypeID}}">{{trailerType.abbrev}} - {{trailerType.description}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Count</label>
                <input type="number" class="form-control" [(ngModel)]="carrierEquipment.equipmentCount" pattern="[0-9]{10}" min="0" step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Length</label>
                <input type="number" class="form-control" [(ngModel)]="carrierEquipment.trailerLength" pattern="[0-9]{10}" min="0" step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
